import { createSelector } from '@reduxjs/toolkit';
import { externalConnectionsForMap } from './external-connections-for-map';

export const externalConnectionsOnNhn = createSelector(externalConnectionsForMap, (externalConnections) =>
  externalConnections.filter(function (c) {
    return c.connectionType === 'NHN' || c.connectionType === 'NHNotherISP';
  }),
);
